<template>
  <!-- eslint-disable -->
  <v-dialog v-model="show" max-width="800px" persistent>
    <v-card>
      <v-card-title>
        <h3>Carrier Request</h3>
      </v-card-title>

      <v-card-text>
        <v-data-table :mobile-breakpoint="0" class="carrier-request-data-table" :items="carrierRequestPackages" item-key="PackageId" :headers="headers" disable-pagination hide-default-footer :sort-by.sync="sortBy" :sort-desc.sync="descending">
          <template v-slot:item="{ item }">
            <tr>
              <td>{{item.TrackingNumber}}</td>
              <td>{{item.Refrigerated}}</td>
              <td>{{item.Service}}</td>
              <td>{{item.ContentsValue}}</td>
              <td>
                <v-checkbox class="high-priority-btn" v-model="item.HighPriority"></v-checkbox>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-btn color="primary" class="carrier-request-close-btn" text @click.stop="show=false">Close</v-btn>
        <v-btn color="primary" class="carrier-request-send-btn" :disabled="sending || carrierRequestPackages.length == 0" text @click.stop="sendRequest()">Send</v-btn>
        <v-progress-circular v-show="sending" indeterminate color="primary"></v-progress-circular>
      </v-card-actions>
    </v-card>
  </v-dialog>
<!-- eslint-enable -->
</template>
<script>
import { mapGetters } from "vuex";
import { CALAMITY_NAMESPACE } from "./store/calamityStore";
export default {
  name: "CarrierRequest",
  data() {
    return {
      sending: false,
      show: false,
      calamityActionId: null,
      calamityId: null,
      sortBy: "ContentsValue",
      descending: true,
      headers: [
        {
          text: "TrackingNumber",
          value: "TrackingNumber",
          align: "left"
        },
        {
          text: "Refrigerated",
          value: "Refrigerated",
          align: "left"
        },
        {
          text: "Service",
          value: "Service",
          align: "left"
        },

        {
          text: "Value",
          value: "ContentsValue",
          align: "left"
        },
        {
          text: "High Priority",
          align: "left"
        }
      ]
    };
  },
  computed: {
    ...mapGetters(CALAMITY_NAMESPACE, ["carrierRequestPackages", "loading"])
  },
  created: /* istanbul ignore next */ function() {
    this.$parent.$on("carrierRequest", this.showDialog);
  },
  methods: {
    sendRequest() {
      this.sending = true;
      return this.$store
        .dispatch(`${CALAMITY_NAMESPACE}/SEND_CARRIER_REQUEST`, {
          calamityActionId: this.calamityActionId,
          calamityId: this.calamityId
        })
        .then(res => {
          this.calamityActionId = null;
          this.calamityId = null;
          this.show = false;
          this.sending = false;
          this.$store.dispatch(`${CALAMITY_NAMESPACE}/LOAD`);
        })
        .catch(
          /* istanbul ignore next */ () => {
            this.sending = false;
          }
        );
    },
    showDialog(payload) {
      this.calamityActionId = payload.calamityActionId;
      this.calamityId = payload.calamityId;
      return this.$store
        .dispatch(`${CALAMITY_NAMESPACE}/LOAD_CARRIER_REQUEST`, {
          calamityId: payload.calamityId
        })
        .then(res => {
          this.show = true;
        });
    }
  }
};
</script>
